import { dictionaryApi } from './dictionaryClient';
import {
  SUBANTA_BACHAN,
  SUBANTA_BARGA,
  SUBANTA_LINGA,
  SUBANTA_PRAKAR,
  SUBANTA_SHRENI,
  SUBANTA_VYUTPANNA,
} from '../constants/subantaEnums';
import type { Artha } from './arthaApi';
import type { DictionaryNotification } from './notificationApi';
import type { DictionaryStat } from './statsApi';

export type SubantaLinga = (typeof SUBANTA_LINGA)[number];
export type SubantaVyutpanna = (typeof SUBANTA_VYUTPANNA)[number];
export type SubantaPrakar = (typeof SUBANTA_PRAKAR)[number];
export type SubantaShreni = (typeof SUBANTA_SHRENI)[number];
export type SubantaBarga = (typeof SUBANTA_BARGA)[number];
export type SubantaBachan = (typeof SUBANTA_BACHAN)[number];

/** Scalar fields stored on Subanta (API shape). */
export type SubantaScalars = {
  word: string;
  base_word: string;
  iast: string;
  linga: SubantaLinga;
  vyutpanna: SubantaVyutpanna;
  prakar: SubantaPrakar;
  shreni: SubantaShreni;
  shatwa: boolean;
  natwa: boolean;
  isVedic: boolean;
  barga: SubantaBarga;
  bachan: SubantaBachan;
};

/** One-to-many relations (TypeORM), included on list/detail when API loads them. */
export type SubantaRelations = {
  vyutpattis?: unknown[];
  nispattis?: unknown[];
  arthas?: Artha[];
  samastaWords?: unknown[];
  samastas?: unknown[];
  rups?: unknown[];
  media?: unknown[];
  stats?: DictionaryStat[] | unknown[];
  notifications?: DictionaryNotification[] | unknown[];
};

/** API row: scalars + id + timestamps + relations. */
export type Subanta = SubantaScalars & {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  /** Some serializers may expose DB column names. */
  created_at?: string;
  updated_at?: string;
} & SubantaRelations;

export type CreateSubantaBody = SubantaScalars;

function normalizeList(data: unknown): Subanta[] {
  if (Array.isArray(data)) return data as Subanta[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: Subanta[] }).data;
  }
  return [];
}

export async function listSubantas(): Promise<Subanta[]> {
  const res = await dictionaryApi.get<unknown>('/subanta');
  return normalizeList(res.data);
}

export async function getSubanta(id: number): Promise<Subanta> {
  const res = await dictionaryApi.get<Subanta>(`/subanta/${id}`);
  return res.data;
}

export async function createSubanta(body: CreateSubantaBody): Promise<Subanta> {
  const res = await dictionaryApi.post<Subanta>('/subanta', body);
  return res.data;
}

export async function updateSubanta(
  id: number,
  body: Partial<SubantaScalars>
): Promise<Subanta> {
  const res = await dictionaryApi.patch<Subanta>(`/subanta/${id}`, body);
  return res.data;
}

export async function deleteSubanta(id: number): Promise<void> {
  await dictionaryApi.delete(`/subanta/${id}`);
}
